import { Component, Inject, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { firstValueFrom, map } from 'rxjs';
import { FreePlayLobbyService } from 'src/app/core/firebase/free-play.service';
import { GameStoreDispatcher } from 'src/app/core/state/game/game.dispatcher';
import { SopoLoadingService } from 'src/app/shared/services/sopo-loading/sopo-loading.service';
import { SopoAlertSettings } from 'src/app/sopo-popup/interfaces/alert';
import { SOPO_DIALOG_DATA, SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';
import { DEFAULT_DISMISS_AFTER_TIME, SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';

@Component({
    selector: 'app-anonymus-quickplay',
    templateUrl: './anonymus-quickplay.component.html',
    styleUrls: ['./anonymus-quickplay.component.scss'],
    standalone: false
})
export class AnonymusQuickplayComponent implements OnInit {
    selectedGame: 'Ring' | 'SNG' | 'MTT' = 'Ring';
    isGuest: boolean = false;

    constructor(
        public sopoDialogRef: SopoDialogRef,
        public navCtrl: NavController,
        @Inject(SOPO_DIALOG_DATA) public data,
        private freePlayService: FreePlayLobbyService,
        private sopoPopupService: SopoPopupService,
        private gameDispatcher: GameStoreDispatcher,
        private sopoLodingService: SopoLoadingService,
    ) { }

    ngOnInit() {
        this.isGuest = this.data?.isGuest ?? false;
    }

    async createQuickplay() {
        const gamesList = await firstValueFrom(this.gameDispatcher.getState().pipe(
            map(gameState => gameState.gamesList))
        );
        if (gamesList.length >= 4) {
            this.sopoPopupService.showAlert("app", {
                message: `You can't open more than 4 tables.`,
                backdropDismiss: false,
            });
            return;
        }
        if (this.selectedGame === 'Ring') this.sopoLodingService.present('api');
        this.freePlayService.createQuickplay(this.selectedGame)
            .then(() => {
                this.sopoLodingService.dismiss('api');
                this.sopoDialogRef.close();
            })
            .catch((error) => {
                this.sopoLodingService.dismiss('api');
                const header = this.selectedGame === 'Ring' ? 'Table creation failed' : 'Tournament creation failed';
                this.showAlert({
                    header: header,
                    message: 'Quickplay is not available right now. Please try again later.',
                    dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
                });
            });
    }

    selectGameType(gameType: "Ring" | "SNG" | "MTT") {
        this.selectedGame = gameType;
    }

    showAlert(options: SopoAlertSettings) {
        this.sopoPopupService.showAlert('app', options);
    }

    close() {
        this.sopoDialogRef.close()
    }

}
